import PageSection from "./page-section"

const NestedPageSection = ({ content, locale, index }) => (
  <PageSection content={content} locale={locale} index={index} />
)

export default NestedPageSection
